<template>
  <v-tooltip top :disabled="!tooltipLines.length" open-delay="150">
    <template v-slot:activator="{ on, attrs }">
      <v-card
        class="indicator-card"
        :class="{ 'indicator-card--clickable': clickable }"
        outlined
        v-bind="attrs"
        v-on="on"
        @click="clickable && $emit('open-detail')"
      >
        <div class="indicator-card-icon" :class="`indicator-card-icon--${color}`">
          <v-icon :color="color" size="22">{{ icon }}</v-icon>
        </div>
        <div class="indicator-card-body">
          <span class="indicator-card-value">{{ value.toLocaleString("pt-BR") }}</span>
          <span class="indicator-card-label">{{ label }}</span>
        </div>
        <v-icon v-if="clickable" size="13" class="indicator-card-hint">mdi-arrow-expand</v-icon>
      </v-card>
    </template>
    <div v-for="(line, i) in tooltipLines" :key="i">{{ line }}</div>
  </v-tooltip>
</template>

<script>
export default {
  name: "IndicatorCard",
  props: {
    label: { type: String, required: true },
    value: { type: Number, required: true },
    icon: { type: String, required: true },
    color: { type: String, default: "primary" },
    clickable: { type: Boolean, default: false },
    // Linhas extras mostradas no hover (ex.: split "já existia" x "nova
    // nesta execução"). Vazio/ausente = sem tooltip (comportamento padrão).
    tooltipLines: { type: Array, default: () => [] },
  },
};
</script>

<style src="./styles.scss" scoped lang="scss" />
